import React, { Component } from "react";
import { Card, CardBody, Col, Row, CardTitle, Alert,Container,Button,Table,Badge,CardFooter,Modal } from "reactstrap";
import { AvForm, AvField,AvInput  } from 'availity-reactstrap-validation';
import {CustomPagination} from "../Common/CustomPagination";
import {DataTabeSearch} from '../Common/DataTabeSearch'
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { createExpenseGroup,expenseGroupList,editExpenseGroup} from '../../../store/expenseGroup/actions';
 
class ExpenseGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
                page: 1,
                per_page: 10,
                search: '',
                customchk: true,
                toggleSwitch: false,
                edittoggleSwitch: false,  
                modal_scroll: false,
                expenseGroup: {
                    
                }
            };
        // this.tog_scroll = this.tog_scroll.bind(this);
    }

    componentDidMount()
    {
        this.fetchexpenseGroupList();  
    }

    
    fetchexpenseGroupList = () => {
        let options = {
            page: this.state.page,
            per_page: this.state.per_page,
            search: this.state.search
        }
        expenseGroupList(options).then((response) => {

            this.setState({
                expenseGroupList :response.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    //modal
    tog_scroll = (expenseGroup) => {
        this.setState(prevState => ({
          modal_scroll: !prevState.modal_scroll,
        }));
        this.state.expenseGroup = expenseGroup;
        this.removeBodyCss();
      }

      removeBodyCss() {
        document.body.classList.add("no_padding");
      }

      // handleValidSubmit
        handleValidSubmit(event, values) {          
            this.props.createExpenseGroup(values);
            this.form && this.form.reset();
            this.fetchexpenseGroupList();     
        }

       
       handleEditSubmit(event, values) {  
            this.props.editExpenseGroup(values);
            this.setState(prevState => ({
                modal_scroll: !prevState.modal_scroll,
              }));

            this.fetchexpenseGroupList(); 
       }

       handleInputChange = (e) => {
        this.setState({[e.target.name]: e.target.value},() => {
            this.fetchexpenseGroupList();
        });
       }

       handlePageClick = (e, index) => {
            e.preventDefault()
            this.setState({
                page: index
            },() => {
                this.fetchexpenseGroupList();
            });
        }

    render() {
      
        let expenseGroupList = [];
        
        let paginator;
        if (this.state.hasOwnProperty('expenseGroupList')) {
            expenseGroupList = this.state.expenseGroupList.data;
            paginator = {
                'currentPage':this.state.expenseGroupList.current_page,
                'pagesCount':this.state.expenseGroupList.last_page,
                'total':this.state.expenseGroupList.total,
                'to':this.state.expenseGroupList.to,
                'from':this.state.expenseGroupList.from,
            }
        }

        const {expense_group_id,expense_group_name,expense_group_name_bangla} = this.state.expenseGroup;

        const getBadge = (status) => {
            return status == 1 ? 'success' : 'secondary'
          }
          
          const getStatusValue = (status) => {
              return status == 1 ? 'Active' : 'In-active'
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>

                        <Breadcrumbs title="Settings" breadcrumbItem="ExpenseGroup" />
                        {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                        {this.props.success && this.props.success ? <Alert color="success">{this.props.success}</Alert> : null}
                        <Row>
                        <Col lg="8" md="8">
                                <Card>
                                    <CardBody>
                                        <CardTitle>ExpenseGroup List</CardTitle>
                                        <div className="table-responsive">
                                        <DataTabeSearch handleInputChange={this.handleInputChange}/>
                                            <Table className="table  mb-0">

                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Expense Group Name</th>
                                                        <th>Expense Group Name (Bangla)</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {expenseGroupList.map((expenseGroup, index) =>
                                                    <tr key={expenseGroup.expense_group_id .toString()}>
                                                        <td scope="row">{index+1}</td>
                                                        <td>{expenseGroup.expense_group_name}</td>
                                                        <td>{expenseGroup.expense_group_name_bangla}</td>
                                                        <td><button type="button"
                                                               className="btn btn-sm btn-primary waves-effect waves-light"
                                                               onClick={() => { this.tog_scroll(expenseGroup) }} 
                                                               data-toggle="modal"
                                                             >Edit</button>
                                                            </td>
                                                       </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                    {paginator &&
                                     <CardFooter className="p-6">
                                          <CustomPagination paginator={paginator} handlePageClick={this.handlePageClick} />
                                      </CardFooter>
                                      }
                                </Card>
                                <Modal
                                 isOpen={this.state.modal_scroll}
                                   toggle={this.tog_scroll}
                                   scrollable={true}
                                   >
                                   <div className="modal-header">
                                       <h5 className="modal-title mt-0">{expense_group_name}</h5>
                                       <button
                                       type="button"
                                       onClick={() =>
                                           this.setState({ modal_scroll: false })
                                       }
                                       className="close"
                                       data-dismiss="modal"
                                       aria-label="Close"
                                       >
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                   <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleEditSubmit(e,v) }}>
                                       {this.props.msg && this.props.msg ? (
                                           <Alert color="success">
                                               expenseGroup Updated Successfully!
                                           </Alert>
                                           ) : null}
                                                
                                                <div className="col-md-12">
                                                    <AvField className="form-control" label="ExpenseGroup Name "  type="text" name="expense_group_name" id="expense_group_name" value={expense_group_name}  required />
                                                     <AvField type="hidden" name="expense_group_id" id="expense_group_id" value={expense_group_id} />
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="ExpenseGroup Name (Bangla) "  type="text" name="expense_group_name_bangla" id="expense_group_name_bangla" value={expense_group_name_bangla} />
                                                 </div>

                                                 
                                           <div className="text-center mt-4">
                                                <button type="button" className="btn btn-light mr-2" onClick={this.tog_scroll}>Close</button>
                                                <button type="submit" className="btn btn-success save-event">Save</button>
                                           </div>
                                   </AvForm>
                                   </div>
                               </Modal>
                            </Col>
                            <Col lg="4" md="4">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Create New ExpenseGroup</CardTitle>
                                        
                                        <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleValidSubmit(e,v) }} ref={c => (this.form = c)}>
                                                
                                             
                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Expense Group Name "  type="text" name="expense_group_name" id="expense_group_name" required/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Expense Group Name (Bangla) "  type="text" name="expense_group_name_bangla" id="expense_group_name_bangla" />
                                                 </div>

                                             <div className=" mt-4">
                                                 <Button type="submit" color="success">Submit</Button>
                                             </div>
                                         </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { msg,error,success } = state.ExpenseGroup;
    return { msg,error,success };
}

export default withRouter(connect(mapStatetoProps, { createExpenseGroup,editExpenseGroup })(ExpenseGroups));
